import * as actions from "../../utils/actions";
import { apiLsDarkModeVariable } from "../../utils/utils";

const darkMode = localStorage.getItem(apiLsDarkModeVariable)
  ? localStorage.getItem(apiLsDarkModeVariable) === "true"
  : true;

export default {
  namespaced: true,
  name: "layout",
  state: {
    collapsed: false,
    openKeys: [],
    selectedKeys: [],
    breakPoint: false,
    screenWidth: 0,
    darkMode: darkMode,
  },
  mutations: {
    [actions.UPDATE_LAYOUT](state, payload) {
      Object.assign(state, payload);
    },
  },
  actions: {
    updateLayout({ commit }, payload) {
      commit(actions.UPDATE_LAYOUT, payload);
    },
  },
  getters: {
    getLayoutDataStore: (state) => {
      return state;
    },
  },
};
